import { withRouter } from 'react-router';

import { removeCreativeAssociationFromProductsUsingCollectionIds } from '../creative-assets/actions';
import { isPC } from '../layout/Variant/Variant';
import { calculateBillableBudget } from '../utils/billable-field-helpers';
import getEventTargetValue from '../utils/get-event-target-value';
import {
  applyFilters,
  changeCampaign,
  clearHighlightedSKUsForProductsUsingCollectionIds,
  clearTextAssetsForProductsUsingCollectionIds,
  clearTextAssetsForProductsUsingContentIds,
  fetchCampaignLineCreatives,
  submit,
  toggleDelayReasonVisibility,
} from './actions';
import CampaignEditor from './CampaignEditor';
import { connectEditor } from './connect-editor';
import { campaignLineStatuses } from './constants';
import campaignDatesChanged from './utils/campaign-dates-changed';
import { checkForHPTO, isPushedToCCP, isPushedToCF } from './utils/utils';

const mapStateToProps = ({ campaign, campaignUI, campaignLinesById }) => ({
  model: campaign,
  isChangeRequestAllowed: Object.values(campaignLinesById).some(line =>
    [
      campaignLineStatuses.READY,
      campaignLineStatuses.PUSHED,
      campaignLineStatuses.LOCKED,
    ].includes(line.status),
  ),
  billableBudgets: calculateBillableBudget({
    campaign,
    campaignLinesById,
  }),
  isDelayReasonVisible: campaignUI && campaignUI.isDelayReasonVisible,
  campaign,
  campaignLinesById,
  isPushedToCCP: isPushedToCCP(Object.values(campaignLinesById)),
  isPushedToCF: isPushedToCF(Object.values(campaignLinesById)),
  hasHPTOSelected: checkForHPTO(Object.values(campaignLinesById)),
});

const mapDispatchToProps = {
  applyFilters,
  changeCampaign,
  clearHighlightedSKUsForProductsUsingCollectionIds,
  clearTextAssetsForProductsUsingCollectionIds,
  clearTextAssetsForProductsUsingContentIds,
  fetchCampaignLineCreatives,
  submit,
  toggleDelayReasonVisibility,
  removeCreativeAssociationFromProductsUsingCollectionIds,
};

const mergeProps = (
  { campaign, campaignLinesById, ...restStateProps },
  dispatchProps,
  ownProps,
) => ({
  ...restStateProps,
  onSubmit: async event => {
    event.preventDefault();
    const { initialCampaign } = ownProps;
    if (isPC()) {
      const datesChanged = campaignDatesChanged(
        initialCampaign.campaignLines,
        campaignLinesById,
      );

      // check if start date changes for future date
      if (campaign.pcDelayedStartReasons.length === 0 && datesChanged) {
        dispatchProps.toggleDelayReasonVisibility(true);
        return;
      }
    }

    await dispatchProps.removeCreativeAssociationFromProductsUsingCollectionIds();
    dispatchProps.clearHighlightedSKUsForProductsUsingCollectionIds();
    dispatchProps.clearTextAssetsForProductsUsingCollectionIds();
    dispatchProps.clearTextAssetsForProductsUsingContentIds();
    await dispatchProps.submit(initialCampaign);
    await dispatchProps.applyFilters();
    // Update creative associations whenever a campaign line is edited
    await dispatchProps.fetchCampaignLineCreatives();
  },
  onChange: event =>
    dispatchProps.changeCampaign(
      event.target.name,
      getEventTargetValue(event.target),
    ),
  refreshCampaignLineCreatives: () =>
    dispatchProps.fetchCampaignLineCreatives(),
  changeDelayReasonVisibility: visible =>
    dispatchProps.toggleDelayReasonVisibility(visible),
});

// Provide the location as prop, in order to bust the should component render cache
export default withRouter(
  connectEditor(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
  )(CampaignEditor),
);
